// @ts-nocheck
import { useRouteMatch } from '@shared/core';
import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import { useMemo } from 'react';

const category = 'shippingAddress';
const managePage = 'manage';
const shopPage = 'shop';
const adminShopPagePrefix = 'admin';
const publicShopPagePrefix = 'newmarketing';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createObjectWithPagePrefix = (target: any, source: any[]) => {
  if (typeof source[source.length - 1] === 'object') {
    return Object.assign(target, ...source);
  }
  return target;
};

export const shippingAddressTelemetry = createTelemetryObject({
  actions: {
    addressReminderDialogOpened: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'addressReminderDialogOpened',
          actionType: undefined,
        },
        args,
      ),
    addressDialogOpened: (from, ...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'addressDialogOpened',
          actionType: undefined,
          extraInfo: {
            from,
          },
        },
        args,
      ),
    shopCurrencyWarningDialogOpened: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'PostAddNonUSWarningOpened',
        },
        args,
      ),
    shopCurrencyWarningDialogButton: (label, ...args) =>
      createObjectWithPagePrefix(
        {
          category,
          page: 'PostAddNonUSWarning',
          action: 'PostAddNonUSWarningRespond',
          actionType: 'click',
          extraInfo: {
            label,
          },
        },
        args,
      ),
    callNationalAddressSuggestionApi: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'CallNationalAddressSuggestionApi',
          actionType: undefined,
        },
        args,
      ),
    callInternationalAddressSuggestionApi: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'CallInternationalAddressSuggestionApi',
          actionType: undefined,
        },
        args,
      ),
    selectSuggestedAddress: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'SelectSuggestedAddress',
          actionType: 'click',
        },
        args,
      ),
    recommendAddressModification: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'RecommendAddressModification',
          actionType: undefined,
        },
        args,
      ),
    deactivateAddressSuggestions: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'DeactivateAddressSuggestions',
          actionType: 'click',
        },
        args,
      ),
    saveSuggestedAddress: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'ButtonInteracted',
          actionType: 'click',
          label: 'Save Address',
          extraInfo: {
            addressActionType: 'SaveSuggestedAddress',
          },
        },
        args,
      ),
    saveSuggestedAddressModified: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'ButtonInteracted',
          actionType: 'click',
          label: 'Save Address',
          extraInfo: {
            addressActionType: 'SaveSuggestedAddressModified',
          },
        },
        args,
      ),
    saveManualAddress: (...args) =>
      createObjectWithPagePrefix(
        {
          category,
          action: 'ButtonInteracted',
          actionType: 'click',
          label: 'Save Address',
          extraInfo: {
            addressActionType: 'SaveManualAddress',
          },
        },
        args,
      ),
  },
  pages: {},
});

const { TelemetryProvider, useTelemetry } = createTelemetry(shippingAddressTelemetry, { eventId: '', section: '' });

const useShippingAddressTelemetry = (...args: Parameters<typeof useTelemetry>) => {
  const isManagePage = useRouteMatch<{ eventHandle: string; subRoute: string }>('/:eventHandle/edit/registry/manage');
  const adminRouteMatch = useRouteMatch<{ eventHandle: string; subRoute: string }>('/:eventHandle/edit/registry/:subRoute');
  const telem = useTelemetry(...args);

  const { page, pagePrefix } = useMemo(() => {
    const page = isManagePage ? managePage : shopPage;
    const pagePrefix = adminRouteMatch ? adminShopPagePrefix : publicShopPagePrefix;
    return {
      page,
      pagePrefix,
    };
  }, [adminRouteMatch, isManagePage]);

  return useMemo(() => {
    const { updateContext, context, ...analyticFnsMap } = telem;
    const updatedTelemObject = { updateContext, context } as typeof analyticFnsMap & { updateContext: typeof updateContext; context: typeof context };
    Object.keys(analyticFnsMap).forEach(key => {
      if (typeof analyticFnsMap[key] === 'object') {
        updatedTelemObject[key] = {};

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedTelemObject[key]['enter'] = (...args: any[]) => analyticFnsMap[key]['enter'](...args, { pagePrefix, eventId: context?.eventId, category });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedTelemObject[key]['exit'] = (...args: any[]) => analyticFnsMap[key]['exit'](...args, { pagePrefix, eventId: context?.eventId, category });
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedTelemObject[key] = (...args: any[]) => analyticFnsMap[key](...args, { page, pagePrefix, eventId: context?.eventId, category });
      }
    });
    return updatedTelemObject;
  }, [telem, pagePrefix, page]);
};

export { TelemetryProvider as ShippingAddressTelemetryProvider, useShippingAddressTelemetry };
